export default "__VITE_ASSET__DI1lHgiH__"